import React, { Component } from 'react';
import { CSVLink } from "react-csv";
import map from 'lodash/map';
import get from 'lodash/get';
import has from 'lodash/has';
import moment from 'moment';
import unionBy from 'lodash/unionBy';
import isEmpty from 'lodash/isEmpty';
import './ExportToCsv.css';

const exportMessage = 'Export to CSV';
class ExportToCSV extends Component {

  getCreatedByName = (item) => {
    if(item["firstName"] !== undefined && item["lastName"] !== undefined && !isEmpty(item.firstName) && !isEmpty(item.lastName)) {
      return `${item.firstName} ${item.lastName}`
    }
    return 'NA';
  }

  getKeyValue = (object) => {
    const rowsArray = [];
    for (const [index, [key, value]] of Object.entries(Object.entries(object.metrics))) {
        rowsArray.push(<td key={key}>{object.metrics[key] instanceof Array && typeof object.metrics[key] !== undefined ? object.metrics[key].length : 0}</td>);
    }
    return rowsArray;
  };

  getData = (data) => {
    const csvData = [];
    map(data, (d) => {
      let eachUserRow = {
        name: !isEmpty(d.name) ? d.name : 'NA',
        createdDate: moment(d.createdDate).format('MM/DD/YYYY'),
        createdby: this.getCreatedByName(d.createdBy),
        category: !isEmpty(d.category) ? d.category : 'NA',
        subCategory: !isEmpty(d.subCategory) && d.subCategory !== undefined ? d.subCategory : 'NA',
        noOfShares: d.metrics && d.metrics.noOfShares ? d.metrics.noOfShares.length : 0
      }
      csvData.push(eachUserRow);
    });

    return csvData;
  }

  render() {
    const ToolsStaticHeaders = [
      { label: "Tool Name", key: "name" },
      { label: "Date Created", key: "createdDate" },
      { label: "Created By", key: "createdby" },
      { label: "Category", key: "category" },
      { label: "Subcategory", key: "subCategory" },
      { label: "Number of shares", key: "noOfShares" }
    ];

    const { Analytics } = this.props;
    return (
      <div className="col-lg-12 col-md-12 col-sm-12 tool-list-font text-right">
        <span className="linkclass" style={{ lineHeight: '42px' }}><i className="flaticon-export" style={{ marginRight: '8px' }}></i>
          <CSVLink
            data={this.getData(Analytics)}
            headers={ToolsStaticHeaders}
            filename={`Tools Analytics-${moment().format("MM/DD/YYYY")}.csv`}
            separator={","}
            target="_blank"
          >{exportMessage}</CSVLink>
        </span>
      </div>
    )
  }
}

export default ExportToCSV;